import { Button } from '@mui/material';
import {
  CustomDomainsQuery,
  Exact,
  useRemoveCustomDomainMutation,
} from '../../../../../../../generated/graphql';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateRight } from '@fortawesome/pro-regular-svg-icons';
import _ from 'lodash';
import { ResetDomainModal } from './ResetDomainModal';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { ApolloQueryResult } from '@apollo/client';
import classnames from 'classnames';

export const ResetDomainButton = ({
  influencerId,
  domainId,
  refetch,
  label,
  color,
}: {
  influencerId: number;
  domainId: number;
  refetch?: (
    variables?:
      | Partial<
          Exact<{
            id: number;
          }>
        >
      | undefined,
  ) => Promise<ApolloQueryResult<CustomDomainsQuery>>;
  label?: string;
  color?: string;
}) => {
  const [showModal, setShowModal] = useState(false);

  const [removeCustomDomainMutation, { loading: removeDomainLoading }] =
    useRemoveCustomDomainMutation();

  const resetDomain = () => {
    removeCustomDomainMutation({
      variables: {
        domainId,
        influencerId,
      },
    })
      .then(() => {
        toast.success('Domain has been reset successfully!');
        refetch && refetch();
      })
      .catch(() => {
        toast.error('Something went wrong with domain reset!');
      })
      .finally(() => {
        setShowModal(false);
      });
  };

  return (
    <>
      <Button
        variant="text"
        onClick={() => setShowModal(true)}
        disabled={removeDomainLoading}
      >
        <div
          className={classnames('flex gap-1 items-center font-medium', {
            'text-[#DA0000]': !color,
            [`text-[${color}]`]: color,
          })}
        >
          <FontAwesomeIcon icon={faArrowRotateRight} />
          <span>{label || 'Reset your domain'}</span>
        </div>
      </Button>
      <ResetDomainModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={resetDomain}
        isSubmitting={removeDomainLoading}
      />
    </>
  );
};
